import type { ISession } from "@mne-authentication/api";

import { LogClient, type TLogLevel, setupLogging } from "@mnemonic/logging";
import { ArgusUtils, type IEnvConfig } from "@mnemonic/pure-utils";

const isLocal = () => window.location.hostname.startsWith("localhost");

export default async function initializeLogging(session: ISession, target: IEnvConfig): Promise<LogClient> {
  const { apiUrl } = target;
  const sessionKey: string = session?.info ? session.info.sessionKey : null;

  const logLevel = (
    session?.user?.properties["logging.client.level"] ? session.user.properties["logging.client.level"] : "info"
  ) as TLogLevel;

  const logClient = LogClient.init({
    apiUrl,
    sessionKey: sessionKey,
    pageOrigin: __PACKAGE__NAME__,
    version: __PACKAGE__VERSION__,
    logLevel: logLevel,
    logToConsole: !ArgusUtils.isProduction(),
    logToApi: !isLocal(),
  });

  if (!isLocal()) {
    // Sets up some default logging. See https://stash.mnemonic.no/projects/JAV/repos/mne-core/browse/packages/logging/src/setupLogging.ts
    setupLogging(logClient);
  }

  return logClient;
}
